// extracted by mini-css-extract-plugin
export var animationContainer = "_hv-0";
export var asteriskIcon = "_hv-8";
export var conversationLeftSection = "_hv-4";
export var conversationListItem = "_hv-3";
export var conversationMiddleSection = "_hv-5";
export var conversationRightSection = "_hv-6";
export var detailsContent = "_hv-1";
export var listContainer = "_hv-7";
export var modalContent = "_hv-2";